import { svc_addOne, svc_editOne, svc_deleteOne } from "@/services";
import { showServerResponse } from "@/utils/message";
const apiPrefix = "options/category";

const Model = {
	namespace: "m_CategoryOption",
	state: {},
	reducers: {},
	effects: {
		*addOption({ payload }, { call, put }) {
			delete payload.id;
			const response = yield call(svc_addOne, apiPrefix, payload);
			showServerResponse(response);
			return response;
		},
		*updateOption({ payload }, { call, put }) {
			if (payload && payload.id) {
				const response = yield call(svc_editOne, apiPrefix, payload, "id");
				showServerResponse(response);
				return response;
			}
		},
		*updateLinkedItem({ payload }, { call }) {
			return yield call(svc_editOne, "options/category-links", payload, "id");
		},
		*deleteOption({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_deleteOne, "options/delete/category", payload, "id");
			showServerResponse(response);
			return response;
		},
		*reorderOption({ payload }, { call, put }) {
			if (payload && payload.length > 0) {
				const response = yield call(svc_addOne, apiPrefix, payload, "reorder");
				showServerResponse(response);
				return response;
			}
		},
	},
	subscriptions: {},
};

export default Model;
